<template>
  <div>
    <b-row v-if="checkAccessPrivilege('Payment.LoyaltyRedeem.Request.Search')">
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sUsername">Username </label>
                  <b-input id="sUsername" type="text" placeholder="" v-model.trim="sUsername"></b-input>
                </b-col>
                <b-col sm="3">
                  <label for="sStatus">Status&nbsp;&nbsp;</label>
                  <b-form-select id="sStatus" :plain="false" v-model="sStatus">
                    <option :value="null">Please select</option>
                    <option v-for="s in status" :key="s.value" :value="s.value">{{ s.name }}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sStartTime">Add Time (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime" :state="$v.sStartTime.$error?false:null" @blur.native="$v.sStartTime.$touch"></b-input>
                  <div v-if="$v.sStartTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Start Time is required</div>
                  </div>
                </b-col>
                <b-col sm="4">
                  <label class="mr-sm-2" for="sEndTime">Add Time (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime" :state="$v.sEndTime.$error?false:null" @blur.native="$v.sEndTime.$touch"></b-input>
                  <div v-if="$v.sEndTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Start Time is required</div>
                  </div>
                </b-col>
                <b-col sm="4" class="align-self-end">
                  <b-button id="sBtn" variant="primary" @click="searchRequest" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-product-hunt'></i> Redeem Request</h3>
          </b-card-header>
          <b-card-body>
            <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(WithdrawStep)="data">
                <span v-if="data.item.WithdrawStep === 0">No</span>
                <span v-else-if="data.item.WithdrawStep === 1">Yes</span>
              </template>
              <template v-slot:cell(AddStep)="data">
                <span v-if="data.item.AddStep === 0">No</span>
                <span v-else-if="data.item.AddStep === 1">Yes</span>
              </template>
              <template v-slot:cell(Status)="data">
                <span v-if="data.item.Status === 0">Waiting</span>
                <span v-else-if="data.item.Status === 1">Processing</span>
                <span v-else-if="data.item.Status === 2">Success</span>
                <span v-else-if="data.item.Status === 3">Failed</span>
                <span v-else-if="data.item.Status === 4">Marked</span>
              </template>
              <template v-slot:cell(MarkOperator)="data">
                <span v-if="data.item.MarkOperator === null"></span>
                <span v-else-if="data.item.MarkOperator !== null">{{data.item.MarkOperator}}</span>
              </template>
              <template v-slot:cell(action)="data">
                <b-button v-if="data.item.Status === 3 && checkAccessPrivilege('Payment.LoyaltyRedeem.Request.Mark')" variant="warning" @click="markRecord(data.item.Transaction)">Mark</b-button>
              </template>
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'redeem-request-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        status: [
          { name: 'Waiting', value: 0 },
          { name: 'Processing', value: 1 },
          { name: 'Success', value: 2 },
          { name: 'Failed', value: 3 },
          { name: 'Marked', value: 4 }
        ],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Transaction', label: 'Transaction'},
          {key: 'Username', label: 'Username'},
          {key: 'Points', label: 'Points'},
          {key: 'Credits', label: 'Credits'},
          {key: 'WithdrawStep', label: 'Deducted Points'},
          {key: 'AddStep', label: 'Added Credits'},
          {key: 'Status', label: 'Status'},
          {key: 'UpdateTime', label: 'Update Time'},
          {key: 'MarkOperator', label: 'Operator'},
          {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        operator: 0,
        sUsername: '',
        sStatus: '',
        sStartTime: '',
        sEndTime: '',
        markTxn: ''
      }
    },
    watch: {
      currentPage: function () {
        this.searchRequest()
      }
    },
    validations: {
      sUsername: { minLength: minLength(1), maxLength: maxLength(50) },
      sStartTime: { required },
      sEndTime: { required }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      markRecord (txn) {
        this.markTxn = txn
        this.$http.post(this.API_ENDPOINT + '/payment/loyaltypoint/redeem/mark', {'transaction': this.markTxn, 'operator': this.operator}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.searchRequest()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Record Marked')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      searchRequest () {
        let username = this.sUsername
        let status = (this.sStatus === null) ? '' : this.sStatus
        let startTime = this.sStartTime
        let endTime = this.sEndTime
        let queryStr = `?username=${username}&status=${status}&startTime=${startTime}&endTime=${endTime}`
        this.$http.get(this.API_ENDPOINT + '/payment/loyaltypoint/redeem/search' + queryStr, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.requests
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      checkAccessPrivilege (module) {
        if (!module) return true
        return this.PRIVILEGE.includes(module)
      }
    },
    created () {
      let user = JSON.parse(window.sessionStorage.getItem('user'))
      this.operator = user.username
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/loyaltypoint/RedeemRequestTable.vue